import client from "./client";

export const fetchDutyReport = async (params) => (await client.get("/reports/duties", { params })).data;

export const exportDutyReport = async (kind, lang, filters) => {
  const res = await client.get("/reports/duties/export", {
    params: { kind, lang, ...filters },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `duties.${kind}`;
  link.click();
  window.URL.revokeObjectURL(url);
};
